import { LocalStorageDataModel } from "../../constants/local-storage-data-model";
import { Env, getDataFromLocalStorage } from "../../utils/globalUtilities";
import axios from "axios";

const unauthorizedCode = [401];
const bypassErrorToComponentCode = ["FAILURE"];
const generateMachineId = () => {
  return Math.random().toString(36).slice(2, 15);
};

export const MarketingBaseService = axios.create({
  timeout: 60000,
  baseURL: Env().REACT_APP_MARKETING_API,
});

MarketingBaseService.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem(LocalStorageDataModel.AUTH_TOKEN);
    let machineid = localStorage.getItem(LocalStorageDataModel.MACHINE_ID_NEW);

    let contenttoken = localStorage.getItem(
      LocalStorageDataModel.CONTENT_TOKEN
    );

    config.headers = {
      refreshtoken: sessionStorage.getItem("refreshToken") || "",
      machineid: machineid,
    };

    if (token) {
      config.headers = {
        ...config.headers,
        taxmannauthorization: token,
        contenttoken: contenttoken,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

MarketingBaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (bypassErrorToComponentCode.includes(response.data?.ResponseType)) {
      return response;
    }
    if (response && unauthorizedCode.includes(response.status)) {
    }
    return Promise.reject(error);
  }
);
